export class PromoActionUser {
  uid: string;
  code: string;
  dateView: string | null;
  dateParticipate: string | null;
  freeDeliveryNumber: number;

  constructor(dto?: PromoActionUser) {
    this.uid = dto?.uid || '';
    this.code = dto?.code || '';
    this.dateView = dto?.dateView || null;
    this.dateParticipate = dto?.dateParticipate || null;
    this.freeDeliveryNumber = dto?.freeDeliveryNumber || 0;
  }
}

export class PromoActionUserDetails {
  greetings: string;
  wishes: string;
  image: string;

  constructor(dto?: PromoActionUserDetails) {
    this.greetings = dto?.greetings || '';
    this.wishes = dto?.wishes || '';
    this.image = dto?.image || '';
  }
}

export class PromoActionAdmin {
  promoActionId: number;
  promoActionUid: string;
  code: string;
  name: string;
  dateBegin: string | null;
  dateEnd: string | null;
  freeDeliveryNumber: number;
  isDel: boolean;
  isPublished: boolean;
  isActive: boolean;
  isEditable: boolean;

  constructor(dto?: PromoActionAdmin) {
    this.promoActionId = dto?.promoActionId || 0;
    this.promoActionUid = dto?.promoActionUid || '';
    this.code = dto?.code || '';
    this.name = dto?.name || '';
    this.dateBegin = dto?.dateBegin ? dto.dateBegin.replace('T', ' ') : null;
    this.dateEnd = dto?.dateEnd ? dto.dateEnd.replace('T', ' ') : null;
    this.freeDeliveryNumber = dto?.freeDeliveryNumber || 0;
    this.isDel = dto?.isDel || false;
    this.isPublished = dto?.isPublished || false;
    this.isActive = dto?.isActive || false;
    this.isEditable = dto?.isEditable || false;
  }
}

export class PromoActionDetailsAdmin extends PromoActionAdmin {
  greetingsUk: string;
  greetingsEn: string;
  wishesUk: string;
  wishesEn: string;
  image: string;

  constructor(dto?: PromoActionDetailsAdmin) {
    super(dto);
    this.greetingsUk = dto?.greetingsUk || '';
    this.greetingsEn = dto?.greetingsEn || '';
    this.wishesUk = dto?.wishesUk || '';
    this.wishesEn = dto?.wishesEn || '';
    this.image = dto?.image || '';
  }
}
